export enum ForumTabType {
  MY_FEED = "my-feed",
  ACTIVE = "active",
  NEW = "new",
  LATEST = "latest",
  TAGS = "tags",
  MY_TOPICS = "my-topics"
}
